import {
  IItem,
  AbstractDrawableValuedItem,
  AbstractPlainTextItem,
  MovableTextBoxItem,
  TextBoxItem,
  IValueContainable,
  instanceOfIFontSizeAutoAdjustable,
} from "../../../../../../../domain/document/items";
import { IValueAccessible } from "../IValueAccessible";
import { AbstractValueAccessor, AbstractItemValueAccessor } from "./AbstractValueAccessor";

export class TextValueAccessor extends AbstractValueAccessor<string> {
  constructor(source: IItem) {
    super(TextValueAccessor._createAccessor(source));
  }

  private static _createAccessor(source: IItem): IValueAccessible<string> {
    if (source instanceof TextBoxItem) {
      return new TextBoxItemFreeTextAccessor(source);
    } else if (source instanceof MovableTextBoxItem) {
      return new MovableTextBoxItemFreeTextAccessor(source);
    }
    throw new Error("対象外オブジェクト");
  }
}

abstract class AbstractTextValueAccessor<T extends IItem & IValueContainable> extends AbstractItemValueAccessor<T, string> {
  constructor(source: T) {
    super(source);
  }

  protected _set(source: T, value: string): void {
    this.__set(source, value);
    if (source instanceof AbstractDrawableValuedItem) { // TODO: リファクタ.適切なinterfaceを定義すべき.
      source.adjustObjectHeight();
    }
    if (instanceOfIFontSizeAutoAdjustable(source)) {
      source.adjustFontSize();
    }
  }

  protected abstract __set(source: T, value: string): void;
}

abstract class AbstractTextBoxItemFreeTextAccessor<T extends AbstractPlainTextItem> extends AbstractTextValueAccessor<T> {
  constructor(source: T) {
    super(source);
  }

  protected _validate(source: T): void {
    if (!source.isFreeInputable || !source.shouldInputFree) {
      throw new Error("非フリー入力");
    }
  }

  protected _get(source: T): string {
    return source.value;
  }

  protected __set(source: T, value: string): void {
    source.value = value;
  }
}

class TextBoxItemFreeTextAccessor extends AbstractTextBoxItemFreeTextAccessor<TextBoxItem> {
  constructor(source: TextBoxItem) {
    super(source);
  }

  protected _validate(source: TextBoxItem): void {
    super._validate(source);
    if (source.isNumeric) {
      throw new Error("数値入力");
    }
  }
}

class MovableTextBoxItemFreeTextAccessor extends AbstractTextBoxItemFreeTextAccessor<MovableTextBoxItem> {
  constructor(source: MovableTextBoxItem) {
    super(source);
  }
}
